module.exports = __webpack_public_path__ + "img/logo.5a22d33b.png";